import { render, staticRenderFns } from "./couponBox.vue?vue&type=template&id=78819cd1&scoped=true&"
import script from "./couponBox.vue?vue&type=script&lang=js&"
export * from "./couponBox.vue?vue&type=script&lang=js&"
import style0 from "./couponBox.vue?vue&type=style&index=0&id=78819cd1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78819cd1",
  null
  
)

export default component.exports